import React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';

import IntlExposer from 'i18n/IntlExposer';
import { locale, messages, getAllowedLocales } from 'i18n/locale';

const defaultEnLocaleData = require('react-intl/locale-data/en');

const defaultEnLocaleDataFields = defaultEnLocaleData && defaultEnLocaleData[0] && defaultEnLocaleData[0].fields;

const DEFAULT_PLURAL_RULE_FUNCTION = () => 'other';

const allLocaleData = getAllowedLocales().reduce((all, l) => {
  const langLocaleData = require(`react-intl/locale-data/${l.reactIntlLib || l.locale}`); // eslint-disable-line global-require,import/no-dynamic-require
  const langLocaleDefault = langLocaleData && langLocaleData[0];

  if (!langLocaleDefault) return all;

  if (l.reactIntlLib) {
    // eslint-disable-next-line no-param-reassign
    all[l.locale] = {
      locale: l.locale,
      parentLocale: l.reactIntlLib,
      pluralRuleFunction: langLocaleDefault.pluralRuleFunction || DEFAULT_PLURAL_RULE_FUNCTION, // eslint-disable-line global-require,import/no-dynamic-require
      fields: langLocaleDefault.fields || defaultEnLocaleDataFields, // eslint-disable-line global-require,import/no-dynamic-require
    };
  }

  all[l.reactIntlLib || l.locale] = langLocaleDefault; // eslint-disable-line no-param-reassign

  return all;
}, []);

addLocaleData(Object.values(allLocaleData));

export default class AppIntl extends React.Component {
  render() {
    const localeData = allLocaleData[locale] || {};

    return (
      <IntlProvider
        locale={localeData.parentLocale || localeData.locale || locale}
        messages={messages}
        formats={localeData.fields || defaultEnLocaleDataFields}
      >
        <div>
          <IntlExposer />
          {this.props.children}
        </div>
      </IntlProvider>
    );
  }
}

AppIntl.propTypes = {
  children: React.PropTypes.node,
};

AppIntl.defaultProps = {
  children: null,
};
